import React from 'react'
import StepOne from './StepOne'
import StepIndicator from './StepIndicator'
import StepTwo from './StepTwo'
import StepThree from './StepThree'

const StepsHome = () => {
    return (
        <div>
            <div className="flex justify-center items-center mb-4 md:mb-12 pt-10">
                <h1 className="text-3xl md:text-5xl font-extrabold text-center text-[#A67FAA]" style={{ fontFamily: 'Raleway, sans-serif' }}>
                    Explore Flavors, Celebrate Cultures, Share Creations
                </h1>
            </div>
            <StepIndicator currentStep={1} />
            <StepOne />
            <StepIndicator currentStep={2} />
            <StepTwo />
            <StepIndicator currentStep={3} />
            <StepThree />

        </div>
    )
}

export default StepsHome
